module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrap"
  }, [_c('mu-bottom-nav', {
    attrs: {
      "value": _vm.bottomNav
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    staticClass: "home",
    attrs: {
      "value": "1",
      "title": "首页",
      "icon": "home"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "sort",
    attrs: {
      "value": "2",
      "title": "分类",
      "icon": "list"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "cart",
    attrs: {
      "value": "3",
      "title": "购物车",
      "icon": "shopcart"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.cartGoodsNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.cartGoodsNum == 0 ? 'none-badge' : 'custom-badge']
    }
  })], 1), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "mine",
    attrs: {
      "value": "4",
      "title": "我的",
      "icon": "my"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9836d910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/menus.vue
// module id = 415
// module chunks = 68